import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        await api.post("/auth/session", { session_id: sid });
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        const back = sessionStorage.getItem("dt_return");
        sessionStorage.removeItem("dt_return");
        navigate(back && back.startsWith("/") && !back.startsWith("//") ? back : "/", { replace: true });
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return null;
};
